// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"dc7ee0bf476d95b9a556","811":"50d301fc32c6e9b47acf"}[chunkId] + ".js";
};